export default (appData, requirements = []) => {
  const isCached = requirements.reduce(
    (acc, mod) => acc && Object.keys(appData || {}).indexOf(mod) !== -1,
    true,
  );

  return isCached;
};
